import DeleteIcon from "@mui/icons-material/Delete";
import { CsiImage, FormControlLabel, GridColumn, GridRow, IconButton, OverflowText, Radio, Text } from "designSystem/index";
import React, { FunctionComponent } from "react";
import CssColumnGrid from "../../CssColumnGrid";
import landscapeImage from "../images/LandscapeThumbnail.jpg";
import portraitImage from "../images/PortraitThumbnail.jpg";

const LONG_NAME = "Label with a very long name to make sure it overflows";
const SHORT_NAME = "Label";

interface ComponentProps {
	image: string;
	name: string;
};

const LabelComponent: FunctionComponent<ComponentProps> = ({ image, name }) => {
	return (
		<GridRow
			flexWrap="nowrap"
			growChild={1}
			spacing={2}
		>
			<CsiImage
				borderRadius={3}
				src={image}
				width={64}
			/>
			<OverflowText text={name} />
		</GridRow>
	);
};

const RowComponent: FunctionComponent<ComponentProps> = ({ image, name }) => {
	return (
		<GridRow
			alignItems="center"
			flexWrap="nowrap"
			growChild={0}
			spacing={2}
			spacingAround={2}
			textAlign="left"
		>
			<FormControlLabel
				control={<Radio />}
				label={<LabelComponent image={image} name={name} />}
				labelPlacement="end"
			/>
			<IconButton size="small">
				<DeleteIcon />
			</IconButton>
		</GridRow>
	);
};

export default () => {
	return (
		<CssColumnGrid centerContent columns={2}>
			<Text semiBold text="text label" />
			<Text semiBold text="component label" />
			<GridColumn
				border="1px solid silver"
				textAlign="left"
				width={250}
			>
				<FormControlLabel
					control={<Radio />}
					label={LONG_NAME}
					labelPlacement="end"
					wrap={false}
				/>
				<FormControlLabel
					control={<Radio />}
					label={SHORT_NAME}
					labelPlacement="end"
					wrap={false}
				/>
			</GridColumn>
			<GridColumn
				border="1px solid silver"
				width={250}
			>
				<RowComponent image={landscapeImage} name={SHORT_NAME} />
				<RowComponent image={portraitImage} name={LONG_NAME} />
			</GridColumn>
		</CssColumnGrid>
	);
};
